export enum DigestQueryParam {
	EDIT = 'editDigest',
}
